import React, { useState } from "react";
import ArrowImg from "../../assest/arrow.png";
const CommentSection = () => {
  const comments = [
    {
      id: 1,
      author: "Albert Flores",
      timestamp: "March 20, 2024 at 2:37 pm",
      content:
        "Neque porro est qui dolorem ipsum quia quaed inventore veritatis et quasi architecto var sed efficitur turpis qilla sed sit amet finibus eros. Lorem ipsum is simply dummy",
      avatar:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    {
      id: 2,
      author: "Albert Flores",
      timestamp: "March 20, 2024 at 2:37 pm",
      content:
        "Neque porro est qui dolorem ipsum quia quaed inventore veritatis et quasi architecto var sed efficitur turpis qilla sed sit amet finibus eros. Lorem ipsum is simply dummy",
      avatar:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  ];

  return (
    <>
      <div className="container">
        <div
          className="d-flex flex-column align-items-start gap-4 w-100 ms-0 px-3"
          style={{ borderRadius: "20px", maxWidth: "800px" }}
        >
          {/* Header */}
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            {String(comments.length).padStart(2, "0")} Comments
          </h2>

          {/* Each comment as its own card */}
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="p-4 bg-white rounded-lg shadow"
              style={{
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                width: "100%",
                borderRadius: "15px",
              }}
            >
              <div className="d-flex gap-3">
                {/* Avatar */}
                <div className="flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.author}
                    className="rounded-circle"
                    style={{ width: 48, height: 48, objectFit: "cover" }}
                  />
                </div>

                {/* Comment Content */}
                <div className="flex-grow-1">
                  {/* Author and Timestamp */}
                  <div className="mb-2">
                    <h3 className="fw-normal mb-1">{comment.author}</h3>
                    <p className="text-muted small mb-0">{comment.timestamp}</p>
                  </div>

                  {/* Comment Text */}
                  <p
                    className="text-muted small lh-base mb-0 mt-3"
                    style={{ letterSpacing: "1px" }}
                  >
                    {comment.content}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <section>
        <div className="container bg-white">
          <div className="row">
            <div className="col-lg-8 mb-5 comment-form bg-white">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="form-floating">
                    <input
                      type="text"
                      name="firstName"
                      className="form-control"
                      id="floatingFirstName"
                      placeholder="First Name"
                    />
                    <label htmlFor="floatingFirstName">First Name</label>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <div className="form-floating">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      id="floatingEmail"
                      placeholder="Email"
                    />
                    <label htmlFor="floatingEmail">Email</label>
                  </div>
                </div>
              </div>

              <div className="form-floating mb-3">
                <textarea
                  className="form-control"
                  placeholder="Write your message here"
                  id="floatingMessage"
                  style={{ height: "150px" }}
                ></textarea>
                <label htmlFor="floatingMessage">Message</label>
              </div>

              <button className="custom-btn btn rounded-pill d-flex align-items-center gap-2 px-4 py-2 position-relative">
                Post Comment
                <img
                  src={ArrowImg}
                  alt=""
                  className="arrow-hover hover-black"
                  style={{
                    width: "16px",
                    height: "16px",
                    transition: "transform 0.2s ease-in-out",
                  }}
                />
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CommentSection;
